var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    opacity: 0.044,
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.238a2.3 2.3 0 1 1 0 4.6 2.3 2.3 0 0 1 0-4.6zm-4.599 1.642c.368 0 .71.098 1.005.276-.098.94.178 1.872.743 2.6a1.97 1.97 0 1 1-3.142-2.299c.37-.37.871-.577 1.394-.577zm9.198 0a1.971 1.971 0 1 1 0 3.941c-.762 0-1.42-.433-1.748-1.064.565-.73.841-1.662.743-2.601a1.94 1.94 0 0 1 1.005-.276zm-8.87 6.733c0-1.36 1.912-2.464 4.271-2.464s4.27 1.104 4.27 2.464v1.15h-8.54v-1.15zm-3.613 1.15v-.986c0-.913 1.242-1.682 2.924-1.905a2.656 2.656 0 0 0-.624 1.74v1.15h-2.3zm15.768 0h-2.3v-1.15c0-.677-.236-1.294-.624-1.741 1.682.223 2.924.992 2.924 1.905v.985z",
    fill: "#121212",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group-2.8bf2cab38807c186d38dea1da591c031.svg";
export { ForwardRef as ReactComponent };